export default __webpack_public_path__ + "static/media/donut-fourth.413b71fd.png";